module.exports = __webpack_public_path__ + "img/hr-garballo-mini-dry-07.936862a7.png";